import { Collapse } from 'antd';

import ImageC from '../Image';

import classes from './FilterAccordion.module.less';

const FilterAccordion = (props: any) => {
	return (
		<>
			<Collapse
				className={classes.collapse}
				defaultActiveKey={props.ActiveAccordionKey}
				bordered={false}
				expandIconPosition="right"
				expandIcon={({ isActive }) => {
					return (
						<ImageC
							alt="Icon Arrow"
							height={12}
							width={12}
							src={`/icons/arrow-chevron-${isActive ? 'up' : 'down'}.svg`}
						/>
					);
				}}
				onChange={props.onChangeCollapse}
			>
				<Collapse.Panel
					header={props.accordionHeader}
					key={props.accordionKey}
					className={classes['panel-wrapper']}
				>
					{props.children}
				</Collapse.Panel>
			</Collapse>
		</>
	);
};

export default FilterAccordion;
